import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { HelpTitle } from '../../../components/Help/HelpButton';
import CreateQuestionGuide from '../../../components/Help/guides/CreateQuestionGuide';
import { UserContext } from '../../../utils/contexts/UserContext';
import { canOpenPage } from '../../../utils/permissions';

// The section above the title: My Questions, where these pages live (the sidebar marks it), for whoever has that page.
// Anyone else (an expert edits the subject's questions without having it) came from a question's page in the bank,
// whose Edit button passes `from`; otherwise no section is named. Text, not a link: leaving the form keeps nothing.
const sectionKey = (user, from) => {
  if (canOpenPage(user, '/my-questions')) return 'my_questions.title';
  return typeof from === 'string' && from.startsWith('/questions') ? 'nav.question_bank' : null;
};

// The title of the question form's pages (create, edit, draft), with the form's guide ("?") right after it.
// `mode`, `inSubject` and `linked` go to the guide (see CreateQuestionGuide); `children` (the folder and passage tags,
// their notes) go under the title.
export default function FormHeader({ title, mode = 'create', inSubject = false, linked = false, children }) {
  const [t] = useTranslation();
  const { user } = useContext(UserContext) || {};
  const section = sectionKey(user, useLocation().state?.from);
  return (
    <div className="min-w-0">
      {section && <p className="text-sm text-slate-500">{t(section)}</p>}
      <HelpTitle
        helpId="create_question"
        helpTitle={t('help.create_question.title')}
        guide={<CreateQuestionGuide mode={mode} inSubject={inSubject} linked={linked} />}
      >
        {title}
      </HelpTitle>
      {children}
    </div>
  );
}
